import { openBrowserPopup } from 'Helpers/browserPopup'
import useMessageThumbnail from 'Hooks/useMessageThumbnail'
import { sessionId } from 'mailup-react-helpers'
import { useIntl } from 'react-intl'
import { useSetRecoilState } from 'recoil'

import {
  Button,
  BUTTON_VARIANT_NEGATIVE,
  Flex,
  Link,
  LINK_VARIANT_HIGHLIGHT,
  SkeletonLoader,
  Spinner,
  Text,
  TEXT_VARIANT_LIGHT,
  Thumb,
  ThumbContainerFooter,
  ThumbCustomOverlay,
  TruncateAndTooltip
} from 'mailup-web-components'

import { abTestState } from 'Pages/AbTestWizard/recoil/state/abtest'

const BoxThumbnail = ({ item }) => {
  const intl = useIntl()
  const setAbTestState = useSetRecoilState(abTestState)

  const [url, status] = useMessageThumbnail({
    id: item.IdMessaggio,
    hasThumbnail: item.HasThumbnail,
    updateDate: item.LastUpdated
  })

  const OverlayThumb = props => {
    const removeMessage = () => {
      setAbTestState(prev => ({
        ...prev,
        step1: {
          ...prev.step1,
          abTestMessages: prev.step1.abTestMessages.filter(
            f => f.IdMessaggio !== props.id
          )
        }
      }))
    }

    return (
      <>
        <ThumbCustomOverlay>
          <Button
            kind={BUTTON_VARIANT_NEGATIVE}
            onClick={() => removeMessage(props.id)}
          >
            {intl.formatMessage({ id: 'Load.MailupCommon.Remove' })}
          </Button>
        </ThumbCustomOverlay>
      </>
    )
  }

  const openEmailPreview = id => {
    openBrowserPopup(
      `/${sessionId}/messages/email/${id}/preview?sourceCode=listemail&idTriggered=0`
    )
  }

  return (
    <>
      <Thumb
        aspectRatio={268 / 321}
        HoverComponent={OverlayThumb}
        hoverComponentProps={{ id: item.IdMessaggio }}
      >
        {status === 'loading' && <Spinner />}
        {status !== 'loading' && <img src={url} />}
      </Thumb>

      <ThumbContainerFooter>
        <Flex margin='8px 16px' flexDirection='column' maxHeigth='56px'>
          {item.Subject ? (
            <>
              <Link
                variant={LINK_VARIANT_HIGHLIGHT}
                onClick={() => openEmailPreview(item.IdMessaggio)}
              >
                <TruncateAndTooltip text={item.Subject} />
              </Link>
              <Text variant={TEXT_VARIANT_LIGHT}>
                <TruncateAndTooltip
                  text={`${item.IdMessaggio}${item.Note && ' - ' + item.Note}`}
                />
              </Text>
            </>
          ) : (
            <>
              <SkeletonLoader variant='onwhite' />
              <SkeletonLoader variant='onwhite' width='50%' />
            </>
          )}
        </Flex>
      </ThumbContainerFooter>
    </>
  )
}

export default BoxThumbnail
